import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("tmn_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        if (res.data.property) {
          localStorage.setItem("tmn_property", JSON.stringify(res.data.property));
        } else {
          localStorage.removeItem("tmn_property");
        }
      })
      .catch(() => {
        localStorage.removeItem("tmn_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password, property_id) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password, property_id });
      localStorage.setItem("tmn_token", data.token);
      localStorage.setItem("tmn_user", JSON.stringify(data.user));
      if (data.user.property) {
        localStorage.setItem("tmn_property", JSON.stringify(data.user.property));
      } else {
        localStorage.removeItem("tmn_property");
      }
      setUser(data.user);
      return data.user;
    } catch (e) {
      const msg = formatApiError(e?.response?.data?.detail) || e.message;
      setError(msg);
      throw new Error(msg);
    }
  };

  const logout = () => {
    localStorage.removeItem("tmn_token");
    localStorage.removeItem("tmn_user");
    localStorage.removeItem("tmn_property");
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
